import { Component, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'adjuntar-archivos',
  template: `
    <div class="d-flex justify-content-start" title="Adjunto">
      <label id="#archivo" class="btn btn-circle">
        <i class="fas fa-paperclip m-0"></i>
        <input
          id="archivo"
          type="file"
          style="display:none"
          (change)="subirArchivo($event)" />
      </label>
      <!--label class="btn btn-circle" title="link">
        <i class="fas fa-link"></i>
      </label -->
      <!-- button  class="btn btn-circle ml-1 mr-1" title="Fotos" >
        <i class="far fa-image m-0"></i>
      </button>
      <button  class="btn btn-circle ml-1 mr-1" title="Videos" >
        <i class="fas fa-video m-0"></i>
      </button -->
    </div>
  `,
  styles: []
})
export class AdjuntarArchivosComponent implements OnInit {
  @Output() emittArchivos= new EventEmitter()
  constructor() { }

  ngOnInit() {
  }

  public subirArchivo(event : any){
    this.emittArchivos.emit(event)
    //console.log("Archivo -->", event.target.files[0])
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/adjuntar-archivos.component.ts